import usePKCEComposable from 'src/utils/VueOAuth2PKCE/pkce.composable';
import { defineComponent } from 'vue';
export default defineComponent({
    setup() {
        const currentHref = window.location.href;
        const { userid } = usePKCEComposable();
        return {
            currentHref,
            userid,
        };
    },
    name: 'Error404',
});
